// Module pilote — Courrier officiel — Arabe maghrébin
// Les termes administratifs français sont conservés en gras

export const COURRIER_LESSONS_AR = [
  {
    id: 'courrier-1',
    numero: 1,
    titre: "تعرّف على المرسِل",
    sousTitre: "من بعت ليك هذا الخطاب ؟",
    contexte: "وصل لماري خطاب من **CAF**. ما عرفتش منين جاء ولا علاش جاء. خايفة تفتحو.",
    explication: [
      "في الجزء العلوي من الخطاب، دايماً تلقى **اسم الجهة المرسِلة** — مثل CAF، CPAM، impôts، أو البلدية.",
      "ابحث على **رقم الملف** (numéro de dossier) — هذا هو رقمك الشخصي عند هذه الجهة.",
      "**التاريخ** مهم برك — شوف تاريخ الخطاب، مش تاريخ وصولو.",
      "الجهات الرسمية دايماً عندها **شعار رسمي** (logo) في أعلى الصفحة.",
      "إذا ما عرفتيش المرسل، **ما تردّيش** على أي خطاب قبل ما تتأكدي.",
    ],
    question: "وين تلقى اسم الجهة اللي بعتت ليك الخطاب ؟",
    options: [
      { id: 'a', text: "في آخر الخطاب", correct: false },
      { id: 'b', text: "في أعلى الخطاب مع الشعار الرسمي", correct: true },
      { id: 'c', text: "على الظرف فقط", correct: false },
    ],
    explication_reponse: "دايماً شوف في أعلى الصفحة — هناك تلقى اسم الجهة، رقم الملف، والتاريخ. هذي هي المعلومات الأساسية.",
  },
  {
    id: 'courrier-2',
    numero: 2,
    titre: "فهم موضوع الخطاب",
    sousTitre: "علاش بعتو ليك ؟",
    contexte: "ماري فتحت الخطاب. شافت كلمة **'convocation'**. خافت. هذا يعني إيداء ؟",
    explication: [
      "الخطابات الرسمية عندها **3 أنواع رئيسية** : طلب وثائق، موعد (convocation)، أو إشعار بقرار.",
      "**'Convocation'** تعني دعوة لموعد — مش مشكلة، فقط تبعت موعد تمشي فيه.",
      "ابحث على كلمة **'objet'** أو **'concerne'** — هي تشرح ليك علاش كتبو ليك.",
      "الكلمات اللي تخوّف مثل 'mise en demeure' أو 'suspension' — هذي تعني مشكلة حقيقية، تصرّف بسرعة.",
      "إذا ما فهمتيش، **اتصلي بالجهة مباشرة** بالرقم الموجود في الخطاب.",
    ],
    question: "وين تلقى موضوع الخطاب بسرعة ؟",
    options: [
      { id: 'a', text: "في آخر صفحة", correct: false },
      { id: 'b', text: "بجانب كلمة 'objet' أو 'concerne'", correct: true },
      { id: 'c', text: "على الظرف", correct: false },
    ],
    explication_reponse: "كلمة 'objet' أو 'concerne' في أول الخطاب — جملة أو جملتين تشرحو ليك الموضوع بالكامل.",
  },
  {
    id: 'courrier-3',
    numero: 3,
    titre: "تحديد المواعيد النهائية",
    sousTitre: "عندك قداه من الوقت ؟",
    contexte: "الخطاب يقول **'sous 15 jours'**. ماري ما عرفتش من أين تحسب — من تاريخ الخطاب ولا من تاريخ وصولو ؟",
    explication: [
      "الأجل يبدأ من **تاريخ الخطاب** (la date du courrier)، مش من يوم وصولو عندك.",
      "**'Sous 15 jours'** = 15 يوم من تاريخ الخطاب. **'Avant le [date]'** = قبل هذا التاريخ بالضبط.",
      "إذا بقات ليك أقل من 5 أيام، **اتصلي بالجهة فوراً** وقوليهم الوضعية.",
      "دايماً **احتفظي بنسخة** من كل وثيقة ترسليها، مع إثبات الإرسال.",
      "في حالة الشك، **اتصلي قبل ما تنتهي المدة** — الجهات الرسمية عادةً تقبل تمديد الأجل.",
    ],
    question: "من أين يبدأ حساب الـ 15 يوم ؟",
    options: [
      { id: 'a', text: "من يوم وصول الخطاب عندك", correct: false },
      { id: 'b', text: "من تاريخ كتابة الخطاب", correct: true },
      { id: 'c', text: "من يوم ما تفتح الخطاب", correct: false },
    ],
    explication_reponse: "الأجل يبدأ من تاريخ الخطاب — حتى لو وصلك متأخر. إذا بقالك وقت قليل، اتصلي بالجهة فوراً.",
  },
  {
    id: 'courrier-4',
    numero: 4,
    titre: "تحديد الوثائق المطلوبة",
    sousTitre: "شنو يطلبو منك ؟",
    contexte: "الخطاب يطلب **'justificatif de domicile'**. ماري ما عرفتش أي ورقة تجيب.",
    explication: [
      "**'Justificatif de domicile'** = وثيقة تثبت عنوانك — فاتورة كهرباء، غاز، أو إيجار — **ما تتعداش 3 أشهر**.",
      "**'Pièce d'identité'** = بطاقة التعريف أو جواز السفر — لازم يكون ساري المفعول.",
      "**'Relevé d'identité bancaire (RIB)'** = ورقة فيها أرقام حسابك البنكي — تلقاها في بنكك أو على النت.",
      "قبل ما تبعت، **صوّر كل وثيقة** وحتفظ بنسخة عندك.",
      "إذا ما عندكش وثيقة معينة، **اتصلي بالجهة** وسوليهم على بديل — دايماً كاين حل.",
    ],
    question: "شنو هو 'justificatif de domicile' ؟",
    options: [
      { id: 'a', text: "بطاقة التعريف الوطنية", correct: false },
      { id: 'b', text: "فاتورة كهرباء أو إيجار حديثة (أقل من 3 أشهر)", correct: true },
      { id: 'c', text: "شهادة الميلاد", correct: false },
    ],
    explication_reponse: "الـ justificatif de domicile هو وثيقة تثبت عنوانك الحالي — فاتورة كهرباء، ماء، أو إيجار — شرط تكون من أقل من 3 أشهر.",
  },
];
